"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRedux = require("react-redux");

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _gift = require("../../store/gift/gift.selector");

var _useCheckIntegrationsAvailability = require("../../hooks/useCheckIntegrationsAvailability");

var _EmailIntegration = require("./EmailIntegration.styles");

var _EmailIntegrationConnect = _interopRequireDefault(require("./EmailIntegrationConnect"));

/**
 * The component is used to avoid sending a gift without integration user email.
 * A user can skip this step if a gift has a flag that integration not required,
 * that setting up in teams settings level.
 *
 * @param {Object} props - Component props.
 * @param {function(): void} props.onSkipIntegration -
 * Callback that called when user skipping email integration.
 * @param {string} [props.linkToIntegration=''] -
 * Link that navigate user to the email integration settings.
 * If it passed email integration buttons will be hidden.
 *
 * @example
 * const onSkipIntegration = useCallback(() => { console.log('Email integration skipped') }, []);
 * const linkToIntegration = 'https://dashboard.alyce.com/settings/common/integrations';
 * return (
 *  <EmailIntegration
 *    onSkipIntegration={onSkipIntegration}
 *    linkToIntegration={linkToIntegration}
 *  />
 * );
 *
 * @returns {React.ReactNode}
 */
var EmailIntegration = function EmailIntegration(_ref) {
  var onSkipIntegration = _ref.onSkipIntegration,
      linkToIntegration = _ref.linkToIntegration,
      integrationStrategy = _ref.integrationStrategy;
  var classes = (0, _EmailIntegration.useStyles)();
  var sender = (0, _reactRedux.useSelector)(_gift.getGiftSender);
  var requireEmailIntegration = (0, _reactRedux.useSelector)(_gift.getRequireEmailIntegration);
  var isSendAsUsed = (0, _reactRedux.useSelector)(_gift.getIsSendAsUsed);
  var isDkimProvider = (0, _reactRedux.useSelector)(_gift.getIsDkimEmailProvider);
  var handleStartIntegrationChecking = (0, _useCheckIntegrationsAvailability.useCheckIntegrationsAvailability)(linkToIntegration);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    p: 3,
    flexDirection: "column",
    color: "text.primary"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    pl: 3.5,
    pb: 3,
    color: "primary.main"
  }, /*#__PURE__*/_react.default.createElement(_material.Typography, {
    variant: "h4"
  }, isDkimProvider ? 'Before crafting your message, you need to integrate your calendar!' : 'Before crafting your message, you should connect your email and calendar account!')), /*#__PURE__*/_react.default.createElement(_material.Typography, null, isDkimProvider ? 'Integrating your account allows Alyce to book meetings on your behalf.' : "Connecting your account allows Alyce to send invites and book meetings on your behalf. \n          It\u2019s also the best way for your invites to end up in your recipient\u2019s inbox as opposed to their spam folders."), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3,
    display: "flex"
  }, isSendAsUsed ? /*#__PURE__*/_react.default.createElement("b", null, sender.full_name, " hasn't connected their email") : /*#__PURE__*/_react.default.createElement(_EmailIntegrationConnect.default, {
    linkToIntegration: linkToIntegration,
    integrationStrategy: integrationStrategy,
    onSetupIntegration: handleStartIntegrationChecking
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    mt: 3
  }, requireEmailIntegration === 'show' && /*#__PURE__*/_react.default.createElement(_material.Button, {
    "data-testid": "GiftingFlow.ContinueWithoutIntegration.Button",
    variant: "text",
    className: (0, _classnames.default)('Button-Link', classes.linkButton),
    onClick: onSkipIntegration,
    endIcon: /*#__PURE__*/_react.default.createElement(_ui.Icon, {
      icon: "chevron-right"
    })
  }, "Or continue without connecting")));
};

EmailIntegration.propTypes = {
  onSkipIntegration: _propTypes.default.func.isRequired,
  integrationStrategy: _propTypes.default.string,
  linkToIntegration: _propTypes.default.string
};
EmailIntegration.defaultProps = {
  linkToIntegration: '',
  integrationStrategy: undefined
};

var _default = /*#__PURE__*/(0, _react.memo)(EmailIntegration);

exports.default = _default;